import React, { useState } from 'react';
import { Search, Share2, X } from 'lucide-react';
import '../styles/Navbar.css';

const Navbar = ({
    searchQuery,
    setSearchQuery,
    sortBy = 'publish_date',
    onSortChange,
    selectedCount = 0,
    onBulkShare,
    onClearSelection
}) => {
    // Local state to track input value without triggering API calls
    const [localSearchQuery, setLocalSearchQuery] = useState(searchQuery);

    // Handle key press events (Enter or Space)
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            // Only trigger API call if there's a change
            if (localSearchQuery !== searchQuery) {
                setSearchQuery(localSearchQuery);
            }
        } else if (e.key === ' ') {
            // Don't preventDefault for space - let it be typed
            // Trigger search after a brief delay to allow the space to be added
            setTimeout(() => {
                setSearchQuery(localSearchQuery + ' ');
            }, 0);
        }
    };

    // Handle search icon click
    const handleSearchClick = () => {
        // Only trigger API call if there's a change
        if (localSearchQuery !== searchQuery) {
            setSearchQuery(localSearchQuery);
        }
    };

    // OLD:
    // return (
    //     <div className="navbar-news">
    //         <div className="navbar-content-news">
    //             <div className="navbar-left-news">
    //                 <div className="logo-icon-news"></div>
    //                 <h1 className="logo-text-news">GROWTH IQ NEWS</h1>
    //             </div>
    //             <div className="search-container-navbar-news">
    //                 <div className="search-wrapper-news">
    //                     <input
    //                         type="text"
    //                         placeholder="What are you looking for?"
    //                         value={localSearchQuery}
    //                         onChange={(e) => setLocalSearchQuery(e.target.value)}
    //                         onKeyDown={handleKeyDown}
    //                         className="search-input-news"
    //                     />
    //                     <Search
    //                         className="search-icon-news"
    //                         size={20}
    //                         onClick={handleSearchClick}
    //                         style={{ cursor: 'pointer' }}
    //                     />
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    // );
    return (
        <div className="navbar-news">
            <div className="navbar-content-news">
                <div className="navbar-left-news">
                    <div className="logo-icon-news"></div>
                    <h1 className="logo-text-news">GROWTH IQ NEWS</h1>
                </div>
                <div className="navbar-search-group-news">
                    {selectedCount > 0 && (
                        <div className="navbar-action-buttons-news">
                            <button
                                className="bulk-share-button-news"
                                onClick={onBulkShare}
                                aria-label={`Share ${selectedCount} selected article${selectedCount > 1 ? 's' : ''}`}
                            >
                                <Share2 size={16} />
                                <span>Share ({selectedCount}/5)</span>
                            </button>
                            <button
                                className="clear-selection-button-news"
                                onClick={onClearSelection}
                                aria-label="Clear all selections"
                            >
                                <X size={16} />
                                <span>Clear</span>
                            </button>
                        </div>
                    )}
                    <div className="search-container-navbar-news">
                        <div className="search-wrapper-news">
                            <input
                                type="text"
                                placeholder="What are you looking for?"
                                value={localSearchQuery}
                                onChange={(e) => setLocalSearchQuery(e.target.value)}
                                onKeyDown={handleKeyDown}
                                className="search-input-news"
                            />
                            <Search
                                className="search-icon-news"
                                size={20}
                                onClick={handleSearchClick}
                                style={{ cursor: 'pointer' }}
                            />
                        </div>
                    </div>
                </div>
                <div className="navbar-sort-news">
                    <span className="sort-label-navbar-news">Sort by:</span>
                    <select
                        className="sort-select-navbar-news"
                        value={sortBy}
                        onChange={(e) => onSortChange && onSortChange(e.target.value)}
                    >
                        <option value="importance">Importance</option>
                        <option value="publish_date">Publish Date</option>
                    </select>
                </div>
            </div>
        </div>
    );
};

export default Navbar;
